import {
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  IconButton,
  Text,
  Tooltip,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Icon,
  Button,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  DownloadIcon,
  DeleteIcon,
} from "@chakra-ui/icons";

import { API_SERVER } from "config/constant";

// Custom components
import Card from "components/card/Card";
import FileDownload from "js-file-download";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
import InvoiceApi from "api/invoice";
import { toast } from "react-toastify";
export default function InvoiceTable({
  columnsData,
  tableData,
  fetchInvoices,
}) {
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  var user = localStorage.getItem("user");

  user = JSON.parse(user);

  const deleteInvoice = (id) => {
    InvoiceApi.delete({ id }).then((res) => {
      if (res.status === 200) {
        toast.success("Invoice deleted successfully.");
        fetchInvoices();
      }
    });
  };

  const downloadInvoice = (id) => {
    InvoiceApi.download(id).then((res) => {
      if (res.status === 200) {
        FileDownload(res.data, `CarHunters_Invoice_${id}.pdf`);
        toast.success("Invoice downloaded successfully.");
      } else {
        console.log(res);
      }
    });
  };

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;

  initialState.pageSize = 10;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Invoices
        </Text>
      </Flex>
      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";

                  if (cell.column.Header === "STATUS") {
                    data = (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color={"green.500"}
                          as={MdCheckCircle}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          SENT
                        </Text>
                      </Flex>
                    );
                  } else if (cell.column.Header === "ACTION") {
                    data = (
                      <>
                        {user.role != "user" && (
                          <Button
                            size="sm"
                            colorScheme="red"
                            mr="10px"
                            mb="5px"
                            onClick={() => deleteInvoice(row.original.id)}
                          >
                            <Icon w="20px" h="20px" me="5px" as={DeleteIcon} />
                            Delete
                          </Button>
                        )}
                        <Button
                          size="sm"
                          mb="5px"
                          colorScheme="green"
                          onClick={() => downloadInvoice(row.original.id)}
                        >
                          <Icon w="20px" h="20px" me="5px" as={DownloadIcon} />
                          Download
                        </Button>
                      </>
                    );
                  } else if (cell.column.Header === "CREATED AT") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {`${new Date(
                          cell.value
                        ).toLocaleDateString()} ${new Date(
                          cell.value
                        ).toLocaleTimeString()}`}
                      </Text>
                    );
                  } else if (
                    cell.column.Header === "AUCTION" ||
                    cell.column.Header === "LOCATION"
                  ) {
                    const upperCaseValue = cell.value ? cell.value.toUpperCase() : '';
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {upperCaseValue}
                      </Text>
                    );
                  } else {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }

                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Flex justifyContent="space-between" m={4} alignItems="center">
        <Flex>
          <Tooltip label="First Page">
            <IconButton
              onClick={() => gotoPage(0)}
              isDisabled={!canPreviousPage}
              icon={<ArrowLeftIcon h={3} w={3} />}
              mr={4}
            />
          </Tooltip>
          <Tooltip label="Previous Page">
            <IconButton
              onClick={previousPage}
              isDisabled={!canPreviousPage}
              icon={<ChevronLeftIcon h={6} w={6} />}
            />
          </Tooltip>
        </Flex>

        <Flex alignItems="center">
          <Text flexShrink="0" mr={8}>
            Page{" "}
            <Text fontWeight="bold" as="span">
              {pageIndex + 1}
            </Text>{" "}
            of{" "}
            <Text fontWeight="bold" as="span">
              {pageOptions.length}
            </Text>
          </Text>
          <Text flexShrink="0">Go to page:</Text>{" "}
          <NumberInput
            ml={2}
            mr={8}
            w={28}
            min={1}
            max={pageOptions.length}
            onChange={(value) => {
              const page = value ? value - 1 : 0;
              gotoPage(page);
            }}
            defaultValue={pageIndex + 1}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
          <Select
            w={32}
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </Select>
        </Flex>

        <Flex>
          <Tooltip label="Next Page">
            <IconButton
              onClick={nextPage}
              isDisabled={!canNextPage}
              icon={<ChevronRightIcon h={6} w={6} />}
            />
          </Tooltip>
          <Tooltip label="Last Page">
            <IconButton
              onClick={() => gotoPage(pageCount - 1)}
              isDisabled={!canNextPage}
              icon={<ArrowRightIcon h={3} w={3} />}
              ml={4}
            />
          </Tooltip>
        </Flex>
      </Flex>
    </Card>
  );
}
